import { H1, h2, P1 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled, { keyframes } from 'styled-components';

import { FlexColumn } from 'styles/layouts';

// This animation moves the background image up and down
const floatAnimation = keyframes`
  0% { background-position: center 0%; }
  50% { background-position: center 100%; }
  100% { background-position: center 0%; }
`;

export const Headline = styled(H1)`
  ${h2};
`;

export const Wrapper = styled(FlexColumn)`
  z-index: ${themeStyle.zIndexS2};
  width: 100%;
  min-height: 120px;
  border-radius: 12px;
  position: relative;
  background-image: url(https://static.kittl.com/template_banner_background.jpg);
  background-size: cover;
  background-position: center 0px;
  // Tells browser this property will animate, allowing it to optimize the animation
  will-change: background-position;
  // Forces GPU acceleration for smoother animation performance
  transform: translate3d(0, 0, 0);

  animation: ${floatAnimation} 120s ease-in-out infinite;
  animation-delay: -10s;

  ${QUERIES.tabletAndUp} {
    min-height: 140px;
  }
`;

export const Content = styled.div<{ enableTopMargin: boolean }>`
  margin: ${(props) =>
    `${props.enableTopMargin ? '60px' : '36px'} 0px 38px 0px`};
  align-items: center;
  text-align: center;

  ${QUERIES.largeTabletAndUp} {
    margin: 38px 40px 38px 40px;
  }
`;

export const TextWrapper = styled(FlexColumn)`
  align-items: center;
  text-align: center;
  padding: 0 24px;
  margin: 0 auto;
`;

export const Description = styled(P1)`
  color: ${themeStyle.backgroundAlt};
  font-weight: ${themeStyle.fontMedium};
  font-size: ${themeStyle.fontSize16};
  line-height: 25.6px;
  text-align: center;

  max-width: 640px;
  margin-top: 16px;
`;
